// extracted by mini-css-extract-plugin
export var box = "_5w-1";
export var checked = "_5w-2";
export var descriptionSpacer = "_5w-9";
export var disabled = "_5w-3";
export var icon = "_5w-6";
export var input = "_5w-0";
export var labelSpacer = "_5w-8";
export var medium = "_5w-5";
export var small = "_5w-4";
export var text = "_5w-7";